let modalId = 1;
export function makeModal(type, options) {
    return {
        id: modalId++,
        type,
        options
    };
}

//# sourceMappingURL=makeModal.js.map